// 菜单相关模拟数据

// 菜单列表模拟数据
export const mockMenuList = [
  {
    id: '1',
    title: '仪表盘',
    path: '/dashboard',
    icon: 'DashboardOutlined',
    sort: 1,
    status: 1,
    createTime: '2024-01-01 10:00:00',
  },
  {
    id: '2',
    title: '用户管理',
    path: '/user',
    icon: 'UserOutlined',
    sort: 2,
    status: 1,
    createTime: '2024-01-02 10:00:00',
  },
  {
    id: '3',
    title: '角色管理',
    path: '/role',
    icon: 'TeamOutlined',
    sort: 3,
    status: 1,
    createTime: '2024-01-03 10:00:00',
  },
  {
    id: '4',
    title: '菜单管理',
    path: '/menu',
    icon: 'MenuOutlined',
    sort: 4,
    status: 1,
    createTime: '2024-01-04 10:00:00',
  },
  {
    id: '5',
    title: '权限管理',
    path: '/permission',
    icon: 'SafetyOutlined',
    sort: 5,
    status: 1,
    createTime: '2024-01-05 10:00:00',
  },
  {
    id: '7',
    title: '太极图',
    path: '/taiji',
    icon: 'ThunderboltOutlined',
    sort: 7,
    status: 1,
    createTime: '2024-01-07 10:00:00',
  },
]

// 菜单树模拟数据（用于导航菜单）
export const mockMenuTree = [
  {
    id: '1',
    name: 'dashboard',
    title: '仪表盘',
    path: '/dashboard',
    icon: 'DashboardOutlined',
    sort: 1,
    status: 1,
    permission: 'dashboard:view',
  },
  {
    id: '2',
    name: 'user',
    title: '用户管理',
    path: '/user',
    icon: 'UserOutlined',
    sort: 2,
    status: 1,
    permission: 'user:view',
    children: [
      {
        id: '2-1',
        name: 'user-list',
        title: '用户列表',
        path: '/user/list',
        sort: 1,
        status: 1,
        permission: 'user:list',
      },
      {
        id: '2-2',
        name: 'user-add',
        title: '添加用户',
        path: '/user/add',
        sort: 2,
        status: 1,
        permission: 'user:add',
      },
    ],
  },
  {
    id: '3',
    name: 'role',
    title: '角色管理',
    path: '/role',
    icon: 'TeamOutlined',
    sort: 3,
    status: 1,
    permission: 'role:view',
    children: [
      {
        id: '3-1',
        name: 'role-list',
        title: '角色列表',
        path: '/role/list',
        sort: 1,
        status: 1,
        permission: 'role:list',
      },
      {
        id: '3-2',
        name: 'role-add',
        title: '添加角色',
        path: '/role/add',
        sort: 2,
        status: 1,
        permission: 'role:add',
      },
    ],
  },
  {
    id: '4',
    name: 'menu',
    title: '菜单管理',
    path: '/menu',
    icon: 'MenuOutlined',
    sort: 4,
    status: 1,
    permission: 'menu:view',
    children: [
      {
        id: '4-1',
        name: 'menu-list',
        title: '菜单列表',
        path: '/menu/list',
        sort: 1,
        status: 1,
        permission: 'menu:list',
      },
      {
        id: '4-2',
        name: 'menu-add',
        title: '添加菜单',
        path: '/menu/add',
        sort: 2,
        status: 1,
        permission: 'menu:add',
      },
    ],
  },
  {
    id: '5',
    name: 'permission',
    title: '权限管理',
    path: '/permission',
    icon: 'SafetyOutlined',
    sort: 5,
    status: 1,
    permission: 'permission:view',
    children: [
      {
        id: '5-1',
        name: 'permission-list',
        title: '权限列表',
        path: '/permission/list',
        sort: 1,
        status: 1,
        permission: 'permission:list',
      },
    ],
  },
  {
    id: '6',
    name: 'system',
    title: '系统管理',
    path: '/system',
    icon: 'SettingOutlined',
    sort: 6,
    status: 1,
    permission: 'system:view',
    children: [
      {
        id: '6-1',
        name: 'config',
        title: '系统配置',
        path: '/system/config',
        sort: 1,
        status: 1,
        permission: 'system:config:view',
        children: [
          {
            id: '6-1-1',
            name: 'config-basic',
            title: '基础配置',
            path: '/system/config/basic',
            sort: 1,
            status: 1,
            permission: 'system:config:basic',
          },
          {
            id: '6-1-2',
            name: 'config-advanced',
            title: '高级配置',
            path: '/system/config/advanced',
            sort: 2,
            status: 1,
            permission: 'system:config:advanced',
          },
        ],
      },
      {
        id: '6-2',
        name: 'log',
        title: '日志管理',
        path: '/system/log',
        sort: 2,
        status: 1,
        permission: 'system:log:view',
      },
    ],
  },
  {
    id: '7',
    name: 'taiji',
    title: '太极图',
    path: '/taiji',
    icon: 'ThunderboltOutlined',
    sort: 7,
    status: 1,
    permission: 'taiji:view',
  },
  {
    id: '8',
    name: 'web3',
    title: '区块链',
    path: '/web3',
    icon: 'WalletOutlined',
    sort: 8,
    status: 1,
    permission: 'web3:view',
    children: [
      {
        id: '8-1',
        name: 'web3-lottery',
        title: 'Lottery 管理',
        path: '/web3/lottery',
        sort: 1,
        status: 1,
        permission: 'web3:lottery:view',
      },
      {
        id: '8-2',
        name: 'web3-approve',
        title: '代币授权',
        path: '/web3/approve',
        sort: 2,
        status: 1,
        permission: 'web3:approve:view',
      },
      {
        id: '8-4',
        name: 'web3-batch-transfer',
        title: '批量转移',
        path: '/web3/batch-transfer',
        sort: 3,
        status: 1,
        permission: 'web3:batch-transfer:view',
      },
      {
        id: '8-3',
        name: 'web3-ipfs-upload',
        title: 'IPFS 上传',
        path: '/web3/ipfs-upload',
        sort: 4,
        status: 1,
        permission: 'web3:ipfs:view',
      },
      {
        id: '8-5',
        name: 'web3-liren',
        title: 'LIREN',
        path: '/web3/liren',
        sort: 5,
        status: 1,
        permission: 'web3:liren:view',
        children: [
          {
            id: '8-5-1',
            name: 'web3-liren-overview',
            title: '合约概览',
            path: '/web3/liren/overview',
            sort: 1,
            status: 1,
            permission: 'web3:liren:overview:view',
          },
          {
            id: '8-5-2',
            name: 'web3-liren-admin',
            title: 'Owner 管理',
            path: '/web3/liren/admin',
            sort: 2,
            status: 1,
            permission: 'web3:liren:admin:view',
          },
          {
            id: '8-5-3',
            name: 'web3-liren-compensation',
            title: '补偿金库',
            path: '/web3/liren/compensation',
            sort: 3,
            status: 1,
            permission: 'web3:liren:compensation:view',
          },
          {
            id: '8-5-4',
            name: 'web3-liren-vesting',
            title: '锁仓查询',
            path: '/web3/liren/vesting',
            sort: 4,
            status: 1,
            permission: 'web3:liren:vesting:view',
          },
          {
            id: '8-5-5',
            name: 'web3-liren-pair',
            title: 'Pair 管理',
            path: '/web3/liren/pair',
            sort: 5,
            status: 1,
            permission: 'web3:liren:pair:view',
          },
        ],
      },
    ],
  },
  {
    id: '10',
    name: 'figma',
    title: 'Figma',
    path: '/figma',
    icon: 'FileTextOutlined',
    sort: 10,
    status: 1,
    permission: 'figma:view',
    children: [
      {
        id: '10-1',
        name: 'article',
        title: '文章详情',
        path: '/figma/article',
        sort: 1,
        status: 1,
        permission: 'figma:article:view',
      },
      {
        id: '10-2',
        name: 'signup',
        title: '注册',
        path: '/figma/signup',
        sort: 2,
        status: 1,
        permission: 'figma:signup:view',
      },
      {
        id: '10-3',
        name: 'ecommerce',
        title: '电商仪表板',
        path: '/figma/ecommerce',
        sort: 3,
        status: 1,
        permission: 'figma:ecommerce:view',
      },
      {
        id: '10-4',
        name: 'finance-academy',
        title: '金融学院',
        path: '/figma/finance-academy',
        sort: 4,
        status: 1,
        permission: 'figma:finance-academy:view',
      },
      {
        id: '10-5',
        name: 'user-profile',
        title: '用户资料卡片',
        path: '/figma/user-profile',
        sort: 5,
        status: 1,
        permission: 'figma:user-profile:view',
      },
      {
        id: '10-6',
        name: 'chaiyao-home',
        title: '柴窑首页',
        path: '/figma/chaiyao-home',
        sort: 6,
        status: 1,
        permission: 'figma:chaiyao-home:view',
      },
    ],
  },
]

// 菜单状态选项
export const mockMenuStatusOptions = [
  { label: '正常', value: 1, color: 'green' },
  { label: '禁用', value: 2, color: 'red' },
]

// 菜单类型选项
export const mockMenuTypeOptions = [
  { label: '目录', value: 'directory' },
  { label: '菜单', value: 'menu' },
  { label: '按钮', value: 'button' },
]
